import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import Verification from '../../components/Verification';
import useErrors from '../../hooks/useErrors';
import { useStore } from '../../stores';
import PhonesService from '../../services/PhonesService';

export default function V3() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { setVerification, userData } = useStore(useShallow((state) => ({
    setVerification: state.setVerification,
    userData: state.userData,
  })));

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  const { phone } = userData || {};

  function handleCode(e) {
    setCode(e.target.value);

    removeError('code');
  }

  async function onSubmit() {
    try {
      setLoading(true);

      if (!code) {
        setError({ field: 'code', message: 'O código é obrigátorio' });
        throw new Error('O código está vazio');
      }

      await PhonesService.verifPhone(phone, code);

      setVerification(4);
      navigate('/modelregister/v4');
    } catch (error) {
      const message = error?.response?.data?.error;

      setError({ field: 'code', message });
    } finally {
      setLoading(false);
    }
  }

  const isFormValid = Boolean(code) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Verification v={3} />

        <Title
          title="Valide seu número"
          subtitle="Valide seu número para começar"
        />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Continuar"
          next
          isLoading={loading}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('code')}>
            <label>Código*</label>
            <input
              type="number"
              placeholder="Digite seu código"
              value={code}
              onChange={handleCode}
            />
          </GroupInput>
        </FormAuth>
      </Center>
    </FormContainer>
  );
}
